import { render } from "./formulir.vue?vue&type=template&id=0c1ae5f6"
import script from "./formulir.vue?vue&type=script&lang=js"
export * from "./formulir.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__